<template>
	<router-link :to="path" tag="div">
		<v-list-item
			link
			v-shortkey.once="shortkey"
			@shortkey="irParaPath()"
		>
			<v-list-item-action>
				<v-icon :color="iconColor">{{icon}}</v-icon>
			</v-list-item-action>
			<v-list-item-content>
				<v-list-item-title>{{title}}</v-list-item-title>
			</v-list-item-content>
			<v-list-item-action v-if="$root.showAtalhos">
				<v-badge inline color="grey">
					<span slot="badge">{{shortKeyHint}}</span>
				</v-badge>
			</v-list-item-action>
		</v-list-item>
	</router-link>
</template>

<script>
export default {
    props: [ 'path', 'shortkey', 'iconColor', 'icon', 'title' ],
    computed: {
        shortKeyHint() {
            return this.shortkey.join('+');
        }
    },
    methods: {
		irParaPath() {
			if (this.$route.path !== this.path) this.$router.push(this.path);
		}
	}
};
</script>